export default {
  namespaced: true,
  state: {
    currentReport: null,
  },

  actions: {},

  getters: {
    currentReport(state) {
      return state.currentReport
    },
  },

  mutations: {
    // Finances report chart
    SET_CURRENT_REPORT(state, data) {
      state.currentReport = data
    },
    CLEAR_CURRENT_REPORT(state) {
      state.currentReport = null
    },
  },
}
